import * as React from 'react';
import { Outlet, Link } from "react-router-dom";
import Footer from "./Footer";
import logo from '../assets/vineyardLogo.png'
import {Box, ListItem, Stack, List } from "@mui/joy";
import './styles/navigator.css'
import ContactModal from './ContactModal';
import GiveModal from './GiveModal';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styled } from '@mui/material/styles';


const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const Navigator = () => {
     const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    return (
        <Box className='navigator-bar' sx={{overflowX: 'hidden'}}>
            <Stack direction='row' sx={{justifyContent: 'space-between', display: {md: 'flex', xs: 'none'}}}>
                <Stack direction='row' className='navigator-content'>
                    <Link className='link' to="/"><img className='nav-image' src={logo} alt='logo'/></Link>
                    <ListItem>
                        <Link className='link-alt' to="/leaders">Who We Are</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/beliefs">Beliefs</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/ministries">Ministries</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/sermons">Sermons</Link>
                    </ListItem>
                    <ListItem>
                        <Link className='link-alt' to="/join">Plan A Visit</Link>
                    </ListItem>
                    <ListItem>
                        <GiveModal linkClass='link-alt' text='Give'/>
                    </ListItem>
                    <ListItem>
                        <ContactModal linkClass='link-alt' text='Contact'/>
                    </ListItem>
                    {/* <NavigationMenu/> */}
                </Stack>
            </Stack>
            <Stack direction='row' spacing={{xs: 20, sm: 65}} sx={{justifyContent: 'space-between', display: {md: 'none', xs: 'flex'}}} className='navigator-content' open={open}>
                <Link className='link' to="/"><img className='nav-image' src={logo} alt='logo'/></Link>
                <IconButton
                    color="black"
                    aria-label="open drawer"
                    edge="end"
                    onClick={handleDrawerOpen}
                    sx={[open && { display: 'none' }]}
                >
                <MenuIcon />
                </IconButton>
                <Drawer
                    sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                    },
                    }}
                    variant="persistent"
                    anchor="right"
                    open={open}
                >
                    <DrawerHeader>
                    <IconButton onClick={handleDrawerClose}><ChevronLeftIcon /></IconButton>
                    </DrawerHeader>
                    <Divider />
                    <List>
                        <ListItem>
                            <Link className='link-alt' to="/leaders">Who We Are</Link>
                        </ListItem>
                        <ListItem>
                            <Link className='link-alt' to="/beliefs">Beliefs</Link>
                        </ListItem>
                        <ListItem>
                            <Link className='link-alt' to="/ministries">Ministries</Link>
                        </ListItem>
                        <ListItem>
                            <Link className='link-alt' to="/sermons">Sermons</Link>
                        </ListItem>
                        <ListItem>
                            <Link className='link-alt' to="/join">Plan A Visit</Link>
                        </ListItem>
                        <ListItem>
                            <GiveModal linkClass='link-alt' text='Give'/>
                        </ListItem>
                        <ListItem>
                            <ContactModal linkClass='link-alt' text='Contact'/>
                        </ListItem>
                    </List>
                </Drawer>
            </Stack>
            <Outlet/>
            <Footer/>
        </Box>
    )
};

export default Navigator;
